import { SavvyMaritalStatus } from "@savvyinsure/savvy-auto-policy/lib/enums";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import isOdd from "../../utils/isOdd";
dayjs.extend(customParseFormat);
export function limitDateValue(val, max) {
    if (val.length === 1 && Number(val) > Number(max[0])) {
        return "0".concat(val);
    }
    if (val.length === 2) {
        if (Number(val) > Number(max)) {
            return max;
        }
    }
    return val;
}
export function formatDOB(value) {
    var mon = value.substring(0, 2);
    var day = value.substring(2, 4);
    var year = value.substring(4, 8);
    var formatMon = limitDateValue(mon, "12");
    var lastDayOfMonth = dayjs("".concat(formatMon, "/01/1990"), "MM/DD/YYYY")
        .endOf("month")
        .format("DD");
    var formatDay = limitDateValue(day, lastDayOfMonth);
    return "".concat(formatMon).concat(formatDay ? "/".concat(formatDay) : "").concat(year ? "/".concat(year) : "");
}
export function validateDrivers(drivers) {
    if (drivers.length < 1) {
        return false;
    }
    var marriedDrivers = drivers.filter(function (driver) { return driver.maritalStatus === SavvyMaritalStatus.Married; });
    var isMissingSpouse = isOdd(marriedDrivers === null || marriedDrivers === void 0 ? void 0 : marriedDrivers.length);
    return (drivers.every(function (driver) { return Object.values(driver).every(Boolean); }) &&
        !isMissingSpouse);
}
export function validatePropertyYearBuiltFormat(value) {
    return dayjs("01/01/".concat(value), "MM/DD/YYYY", true).isValid();
}
export function validatePropertyYearBuiltIsNotFutureYear(value) {
    return dayjs("01/01/".concat(value), "MM/DD/YYYY", true).isBefore(dayjs().add(1, "year"), "year");
}
export function validatePropertySquareFootage(value) {
    return value && !isNaN(value) && "".concat(value).length >= 3;
}
export function transformVehicleInfoToSelectOption(_a) {
    var id = _a.id, name = _a.name;
    return { value: id, label: name };
}
export function isDriverMarried(driver) {
    return (driver === null || driver === void 0 ? void 0 : driver.maritalStatus) === SavvyMaritalStatus.Married;
}
